/** @format */

import { cssVars } from '@atoms/GlobalStyles';
import eProps from '@common/application/types/EmotionStyledProps';
import chroma from 'chroma-js';

interface ThemeProps {
  warning?: boolean;
  error?: boolean;
  disabled?: boolean;
  active?: boolean;
}

type esComponentProps = ThemeProps & eProps;

const resolveCssVar = (val: string) => {
  if (!val.startsWith('var(')) {
    return val;
  }
  if (typeof window === 'undefined') {
    return val;
  }
  const varName = val.slice(4, -1).trim();
  const resolved = getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
  return resolved || val;
};

const d = (val: string) => {
  const resolved = resolveCssVar(val);
  try {
    return chroma(resolved).darken(0.2).hex();
  } catch {
    return resolved;
  }
};

//<editor-fold desc="Style Getters">
const getBorderColor = (props: esComponentProps) => {
  if (props.error) {
    return cssVars.red;
  }
  if (props.warning) {
    return cssVars.yellow;
  }
  return cssVars.lightGrey;
};

const getBackgroundColor = (props: esComponentProps) => {
  if (props.error) {
    return cssVars.red;
  }
  if (props.warning) {
    return cssVars.yellow;
  }
  return 'var(--grey-100)';
};

const getColor = (props: esComponentProps) => {
  if (props.error || props.warning) {
    return cssVars.yellow;
  }
  return 'var(--black)';
};

const getHoverBorderColor = (props: esComponentProps) => {
  if (props.warning || props.error) {
    return 'var(--grey-100)';
  }
  return 'var(--primary-500)';
};

const getHoverColor = (props: esComponentProps) => {
  if (props.warning || props.error) {
    return 'var(--grey-100)';
  }
  return 'var(--primary-500)';
};

const getActiveBorderColor = (props: esComponentProps) => {
  if (props.warning) {
    return d('var(--grey-100)');
  }
  return d('var(--primary-500)');
};

const getActiveColor = (props: esComponentProps) => {
  if (props.warning) {
    return d('var(--grey-100)');
  }
  return d('var(--primary-500)');
};
//</editor-fold>

export const styles = {
  borderColor: getBorderColor,
  backgroundColor: getBackgroundColor,
  color: getColor,
  hover: {
    borderColor: getHoverBorderColor,
    color: getHoverColor,
  },
  active: {
    borderColor: getActiveBorderColor,
    color: getActiveColor,
  },
};
